"use client";

import { useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils"; // or your cn utility

// Reusable lazy image with skeleton loader
export default function LazyImage({
  src,
  alt,
  width,
  height,
  priority = false,
  className,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
  priority?: boolean;
  className?: string;
}) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative w-full overflow-hidden rounded-lg">
      {/* Skeleton shimmer — shown until image loads */}
      {!isLoaded && (
        <div className="absolute inset-0 animate-pulse bg-linear-to-r from-white/10 via-white/25 to-white/10 bg-size-[200%_100%] animate-shimmer rounded-lg" />
      )}

      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        priority={priority} // eager-load the first visible image
        loading={priority ? "eager" : "lazy"} // explicit for clarity
        placeholder="blur" // built-in Next.js blur-up effect
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==" // tiny 1px placeholder
        onLoad={() => setIsLoaded(true)}
        className={cn(
          "w-full object-cover rounded-lg transition-opacity duration-500",
          isLoaded ? "opacity-100" : "opacity-0", // fade in on load
          className,
        )}
      />
    </div>
  );
}
